// extracted by mini-css-extract-plugin
export default {"serverErrorTextArea":"PortalServerErrorNotification__serverErrorTextArea__sBLMB","debugInfoSpacer":"PortalServerErrorNotification__debugInfoSpacer__iprO9"};